import { ConstantService } from 'app/Shared/Services/constant-service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GridService } from 'app/Shared/Services/grid.service';
import { MessageService } from 'primeng/api';
import { Util } from 'app/Shared/Constant/Util';
import { FieldDictionary } from 'app/Pages/cat-dashboard/finra-exception/field-dictionary.model';
import { EventConversionService } from './event-conversion.service';
import { UserService } from 'app/Shared/Services/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { LowerCasePipe, NgClass, CommonModule, NgStyle } from '@angular/common';
import { MultiSelectModule } from 'primeng/multiselect';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Select } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
@Component({
    selector: 'app-event-conversion',
    imports: [CommonModule, Select, MultiSelectModule, ButtonModule, FormsModule, TableModule, MatDividerModule, LowerCasePipe,
        NgClass, MatTooltipModule, DatePickerModule, NgStyle, ToggleSwitchModule],
    templateUrl: './event-conversion.componenet.html',
    styleUrls: ['./event-conversion.componenet.scss']
})
export class EventConversionComponent implements OnInit {
  @Input() selectedRow: any;
  @Input() pageName!: string;
  @Output() closeDialog: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() fieldDictionaryListInput!: FieldDictionary[];

  fieldDictionaryList!: FieldDictionary[];
  firmROEIDList!: Array<string>
  loadingView!: boolean;
  timeInForceChoice!: string;
  timeInForceValue!: string;
  isClickedOnce!: boolean;
  handlingInstructionData: any;
  booleanDropDown: any;
  givenNameForFDID = '';
  checked: boolean = false;
  checkedFdid: boolean = false;
  fieldDictionaryMap : any[] = [];
  //TO DO: get highlight keys from backend by comparing DDL.
  hightlightKeys:any=["rfqid", "firmdesignatedid", "accountholdertype", "aggregatedorder", "negotiatedtradeflag","representativeind","receiverimid","senderimid", "sendertype", "routedorderid", "isoind", "pairedorderid"];
  newEventType:any = '';
  isErrorRecord:boolean=false;

  constructor(
    public constantService: ConstantService,
    private messageService: MessageService,
    private gridService: GridService,
    public userService:UserService,
    public eventConversionService: EventConversionService) {

  }

  ngOnInit() {
    this.fieldDictionaryListInput.forEach(element => {
      this.fieldDictionaryMap[element.fieldName as any] = element;
    });
    this.newEventType = this.constantService.CONVERT_EVENT_JSON[this.selectedRow.type];
    this.getFiledDictionaryForEditView();
    this.loadingView = false;
    this.booleanDropDown = [{
      label: "true", value: true, description: "True"
    },
    {
      label: "false", value: false, description: "False"
    }];

    this.eventConversionService.getAggoOrdersColumns();
    this.eventConversionService.getTDETColumns();
  }

  getFiledDictionaryForEditView() {
    this.isErrorRecord=false;

    const payload = {
      mpid: this.userService.getActiveMPID(),
      reportDate: this.selectedRow.reportDate,
      groupName: this.selectedRow.groupName,
      newEventType: this.newEventType,
      firmROEID: this.selectedRow.firmROEID,
      fileID: this.selectedRow.fileID
    }

    this.eventConversionService
      .getFiledDictionaryForEditView(payload, this.pageName)
      .subscribe(
        {
          next: (response:any) => {
          this.fieldDictionaryList = response.LIST_FIELDDICTIONARY;
          // get the model value separately for timeinforce
          if( this.fieldDictionaryList) {
            //Default value setting
            this.fieldDictionaryList.forEach(element => {                          
              if (element.fieldName.toLowerCase() === 'timeinforce') {
                if (element.jsonValue !== undefined &&
                  element.jsonValue !== null) {
                const parsedJson = (element.jsonValue);
                this.timeInForceChoice = Object.keys(parsedJson)[0];
                this.timeInForceValue = parsedJson[Object.keys(parsedJson)[0]];
                }
              } else if (element.fieldName.toLowerCase() === 'selldetails' || element.fieldName.toLowerCase() === 'buydetails' ||
                element.fieldName.toLowerCase() === 'clientdetails' || element.fieldName.toLowerCase() === 'firmdetails') {
                element.jsonValue = (element.jsonValue);
              } else if (element.fieldName.toLowerCase() === 'handlinginstructions') {
                let obj: any;
                obj = (element.jsonValue);
                let result = Util.isDefinedAndNotNull(obj) ? Object.keys(obj).map(function (key) {
                  return [(key), obj[key]];
                }) : [];
                this.handlingInstructionData = Util.isDefinedAndNotNull(element.jsonValue) ? [(element.jsonValue)] : [{}];
                this.eventConversionService.handlingInstructionCols = this.gridService.getGridColumnsHasValues(result);
                element.jsonValue = null;
              } else if(element.fieldName.toLowerCase() === 'errorroeid' && element.jsonValue != null){  
                this.isErrorRecord=true;               
              }              
              if (this.hightlightKeys.indexOf(element.fieldName.toLowerCase()) >= 0 && element.jsonValue != null
              && element.fieldName.toLowerCase() != "receiverimid") {
                element.jsonValue = null;
              }
            });
            this.fieldDictionaryList.forEach(element => { 
              if(element.fieldName.toLowerCase() === "actiontype"){
                element.jsonValue = this.pageName =='finraException' && this.isErrorRecord ? "RPR":"COR";
              }
            });
            this.isErrorRecord = false;
          }          
        },
        error: (err: HttpErrorResponse) => {
          this.fieldDictionaryList = [];
        }
      });
  }

  onSave() {
    this.isClickedOnce = true;
    let updatedJSONobject: any = {};
    this.fieldDictionaryList.forEach((element, index) => {
      if (element.jsonValue !== null && element.jsonValue !== "") {
        if (element.fieldName.toLowerCase() === 'selldetails' ||
          element.fieldName.toLowerCase() === 'buydetails' ||
          element.fieldName.toLowerCase() === 'clientdetails' || element.fieldName.toLowerCase() === 'firmdetails') {
          updatedJSONobject[element.fieldName] = (this.fieldDictionaryList[index].jsonValue);
        } else if (element.fieldName.toLowerCase() === 'timeinforce') {
          updatedJSONobject[element.fieldName] = this.timeInForceValue ? { [this.timeInForceChoice]: this.timeInForceValue } : undefined;
        } else {
          updatedJSONobject[element.fieldName] = this.fieldDictionaryList[index].jsonValue;
        }
      } else if (element.fieldName.toLowerCase() === "handlinginstructions" && this.handlingInstructionData) {
        let handlingArr: any = [];
        let handlingObj: any
        this.eventConversionService.handlingInstructionCols.forEach((element: { header: string; }) => {
          let keys = Object.keys(this.handlingInstructionData[0]);
          if (this.handlingInstructionData[0] && Object.keys(this.handlingInstructionData[0]).length > 0 && keys.indexOf(element.header) >= 0) {
            handlingArr.push({ [element.header]: this.handlingInstructionData[0][element.header] })
            handlingObj = Object.assign.apply(Object, handlingArr); // Array of obj into one obj
          }
        });
        updatedJSONobject[element.fieldName] = this.eventConversionService.handlingInstructionCols.length > 0 && handlingObj !== undefined ? this.constantService.removeNullValueObj(handlingObj) : null;
        updatedJSONobject[element.fieldName] = updatedJSONobject[element.fieldName] !== null && Object.keys(updatedJSONobject[element.fieldName]).length === 0 ? null :
          updatedJSONobject[element.fieldName];
        if (updatedJSONobject[element.fieldName] === null) {
          delete updatedJSONobject[element.fieldName];
        }
      }

    });
    updatedJSONobject['type']=this.constantService.CONVERT_EVENT_JSON[this.selectedRow.type];
    // save API call
   
    const convertEventSavePayload = {
      mpid: this.userService.getActiveMPID(),
      reportDate:this.selectedRow.reportDate,
      groupName:this.selectedRow.groupName,
      oldEventType:this.selectedRow.type,
      newEventType:this.constantService.CONVERT_EVENT_JSON[this.selectedRow.type],
      user: this.userService.getUserFirstName(),
      firmROEID:this.selectedRow.firmROEID,
      updatedJSON: updatedJSONobject,
      originalJSON: this.selectedRow.originalJSON

    }
    this.eventConversionService.saveConvertedEvent(convertEventSavePayload, this.pageName)
    .subscribe((data)=> {
      if(data.status) {
        this.givenNameForFDID = '';
        this.checked = false;
        this.checkedFdid = false;
        this.closeDialog.emit(true);
        this.messageService.add({ severity: 'success', summary: 'Update Success Message', detail: 'Record converted successfully' });
      } else {
        this.closeDialog.emit(false);
        this.messageService.add({ severity: 'error', summary: 'Update', detail: 'Record Update Failed!'});
      }
     
    },(err: HttpErrorResponse) => {
      this.messageService.add({ severity: 'error', summary: 'Update', detail: 'Record Update Failed!' });
      this.isClickedOnce = false;
    });
  }



  getFDID(index: number) {
    this.eventConversionService.getFDID(this.givenNameForFDID)
      .subscribe(data => {
        this.fieldDictionaryList[index].jsonValue = data.Data.length > 0 ? data.Data[0].generatedFDID : null;
        if (this.fieldDictionaryList[index].jsonValue === null) {
          this.messageService.add({ severity: 'error', summary: 'Not Found', detail: 'Firm Designated ID not found for given name' });
        } else {
          this.messageService.add({ severity: 'success', summary: 'record Found', detail: 'Updated Firm Designated ID' });
        }
      });
  
  }

  setEditRowValue(index: number, key: string) {
    /* Receiving updated TimeInForce Value */
      let timeInForceValue = this.userService.getTimeInforceValue(key, this.fieldDictionaryList[index].fieldName, true, this.fieldDictionaryList);
      this.timeInForceChoice = key;
      this.timeInForceValue = timeInForceValue;
    /* End of Receiving updated TimeInForce Value */

    this.fieldDictionaryList[index].jsonValue = {
      [key]: timeInForceValue,
    }
  }

}
